import React from 'react';

import { Container, Content, Logo, ColorBar } from './styles';
import ImgLogo from '../../assets/images/logo.svg';

type HeaderProps = {
  loading?: boolean;
};

const Header: React.FC<HeaderProps> = props => {
  const { loading = false } = props;

  return (
    <Container>
      <Content>
        <Logo src={ImgLogo} />
      </Content>
      <ColorBar $loading={loading} />
    </Container>
  );
};

export default Header;
